import { ReactNode } from "react";

type RequirementItemProps = {
  icon: ReactNode;
  text?: string;
};

export default function RequirementItem({ icon, text }: RequirementItemProps) {
  return (
    <div className="flex items-center gap-2 text-sm cursor-pointer">
      <span className="text-black text-sm md:text-lg transition-colors duration-300 group-hover:text-white">
        {icon}
      </span>

      <span className="text-font-alt text-sm md:text-lg transition-colors duration-300 group-hover:text-font-alt">
        {text}
      </span>
    </div>
  );
}
